import { render, staticRenderFns } from "./tit.vue?vue&type=template&id=bd9b8304&scoped=true&"
import script from "./tit.vue?vue&type=script&lang=js&"
export * from "./tit.vue?vue&type=script&lang=js&"
import style0 from "./tit.vue?vue&type=style&index=0&id=bd9b8304&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd9b8304",
  null
  
)

export default component.exports